export default __webpack_public_path__ + "static/media/9_16-card.3030c246.png";